module.exports = __webpack_public_path__ + "i18n/nl.6de76209221e0407c72f76e9d4fb4974.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 1859
// module chunks = 0